import * as i0 from '@angular/core';
import { InjectionToken, Component, Attribute, Input, HostBinding, NgModule } from '@angular/core';

const BC_FUNCTIONAL_ICONS = [
    'currency-euro ',
    'currency-peso',
    'send-message',
    'send',
    'asterisk',
    'security',
    'shield-user',
    'my-products',
    'scooter',
    'game-controller',
    'map',
    'coding',
    'balance',
    'marketplace',
    'power-cord',
    'project',
    'reply-all',
    'forward',
    'reply',
    'token',
    'preparer-User',
    'direct-user',
    'approving-user',
    'user-check',
    'user-error',
    'add-user',
    'main-users',
    'walk',
    'achievement',
    'people',
    'lend',
    'gasoline-tank',
    'bank',
    'attachment',
    'affinity',
    'add-store',
    'store',
    'pending-store',
    'add_square',
    'square',
    'whatsapp-outline',
    'facebook-outline',
    'instagram-outline',
    'linkedin-outline',
    'twitter-outline',
    'youtube-outline',
    'pay-with-wallet',
    'microphone',
    'day-to-day',
    'coin',
    'table-settings',
    'megaphone',
    'baby-bottle',
    'cube-3d',
    'accepted-card',
    'access',
    'add-money',
    'add-to-car',
    'add-doc',
    'address-book',
    'alarm',
    'alert',
    'align-left-1',
    'align-left',
    'align-right',
    'align',
    'amount',
    'analytics',
    'angle-double-down',
    'angle-double-left',
    'angle-double-right',
    'angle-double-up',
    'arrow-diagonal',
    'arrow-down',
    'arrow-left',
    'arrow-long-down',
    'arrow-long-left',
    'arrow-long-right',
    'arrow-long-up',
    'arrow-right',
    'arrow-up',
    'arrow2-down',
    'arrow2-left',
    'arrow2-right',
    'arrow2-up',
    'exchange',
    'assistant',
    'tabot',
    'assistence',
    'ATM',
    'bank-commitments',
    'barcode-scan',
    'barcode',
    'basket',
    'benefits',
    'bicycle',
    'bill',
    'birthday-cake',
    'block',
    'book',
    'bookmark',
    'building',
    'car',
    'bus',
    'calculator',
    'calendar-check',
    'calendar-day',
    'calendar-exclamation',
    'calendar-minus',
    'calendar-plus',
    'calendar-premium',
    'calendar-times',
    'calendar',
    'calendar-edit',
    'month',
    'call-help',
    'camera',
    'capital',
    'car-plate',
    'card',
    'cards',
    'carousel',
    'cash-contribution',
    'cash-payment',
    'cash',
    'channels',
    'chart-line',
    'performance',
    'chart-pie',
    'chat-comments',
    'chat-dots',
    'chat',
    'checks',
    'child',
    'cinema',
    'clave-dinamica',
    'cloud-download',
    'cloud-upload',
    'cloud',
    'cloudy',
    'coffee',
    'comment',
    'construction',
    'contact-center',
    'contactless',
    'countdown',
    'currency-exchange',
    'data',
    'desktop',
    'laptop',
    'smartphone',
    'directions',
    'document-check',
    'document-delivery',
    'document-search',
    'document',
    'documents',
    'door',
    'download-document',
    'download-file',
    'download',
    'e-card',
    'e-prepago',
    'edit-document',
    'edit',
    'modify',
    'education',
    'erase',
    'error',
    'expand',
    'external-link',
    'extinguisher',
    'face-angry',
    'face-grin-wink',
    'face-grin-wink2',
    'face-laugh',
    'face-laughbeam',
    'face-meh',
    'face-sad',
    'face-smile',
    'faceid',
    'file-invoice',
    'filter',
    'filters',
    'finantial-growth-indicator',
    'config',
    'finantial',
    'find-doc',
    'fingerprint',
    'fire',
    'flag',
    'flight-cancelled',
    'flight-late',
    'flight',
    'flypass',
    'folder',
    'burger',
    'gift',
    'gps',
    'grocery',
    'hand-tap',
    'hand-four-fingers',
    'hand-one',
    'hand-three',
    'hand-paper',
    'hand-two',
    'hand-five',
    'health',
    'heart',
    'heart-fill',
    'help',
    'holding-money',
    'home',
    'house',
    'id-number',
    'id',
    'idea',
    'image',
    'inbox',
    'info',
    'insert-coin',
    'insurance',
    'international',
    'investment',
    'language',
    'law',
    'like',
    'line-of-people',
    'twitter',
    'facebook',
    'instagram',
    'linkedin',
    'youtube',
    'secondary-menu-horizontal',
    'secondary-menu',
    'list',
    'menu-bar',
    'location',
    'lock-open',
    'lock',
    'login',
    'luggage',
    'mail-open',
    'mail',
    'medal',
    'medical-assistance',
    'mixed-service',
    'mobile-payment',
    'money-exchange',
    'motorcycle',
    'movie',
    'museum',
    'news',
    'no-card',
    'no-people',
    'no-smoking',
    'no-view',
    'notification',
    'office',
    'package',
    'pass',
    'password',
    'pet',
    'phone-contact',
    'phone-money',
    'play',
    'pocket',
    'plus',
    'percentage',
    'minus',
    'ok',
    'podcast',
    'preferential',
    'premium',
    'star-fill',
    'print',
    'product-number',
    'puntos-colombia',
    'qr-plus',
    'QR-heart',
    'QR-scan',
    'QR-send',
    'quit',
    'receipt',
    'refresh',
    'remove',
    'removing-card',
    'restaurant',
    'route',
    'salary',
    'save',
    'saving',
    'search-chart',
    'search-money',
    'search',
    'see-balance',
    'send-money-from',
    'send-money-to',
    'send-money',
    'send-money-2',
    'settings',
    'share-external-link',
    'share',
    'ship',
    'shopping',
    'shower',
    'smart-watch',
    'sort-amount-up',
    'sound-off',
    'sound-on',
    'spinner',
    'stethoscope',
    'stock-exchange',
    'stocks',
    'subway',
    'successful',
    'sunny',
    'swimming',
    'tag-price',
    'tag-sale',
    'target',
    'taxes',
    'temperature',
    'thumbs-down',
    'thumbs-up',
    'thumbtack',
    'time',
    'trophy',
    'turn',
    'umbrella-beach',
    'undo-payment',
    'unemployment',
    'upload',
    'user',
    'value',
    'variations',
    'view',
    'vip',
    'wallet',
    'window-analytics',
    'withdraw-cash',
    'wrench',
    'zoom-minus',
    'zoom-plus',
    'elderly',
    'face-mask',
    'options-menu',
    'Sufi',
    'foundation',
    'accesibility',
    'arrow3-down',
    'arrow3-left',
    'arrow3-right',
    'arrow3-up',
    'components',
    'widget',
    'mail-safe',
    'ID-key',
    'ID-lock',
    'laptop_chat',
    'phone-chat',
    'receipt-add',
    'receipt-edit',
    'receipt-search',
    'password-safe',
    'chat-safe',
    'add-bank',
    'cat',
    'design',
    'dog',
    'figma',
    'money-edit',
    'error-small',
    'circle-check-filled',
    'settings-filled',
    'document-filled',
    'square-filled',
    'money-filled',
    'home-filled',
    'flywheel',
    'tire',
    'mileage',
    'bus-card',
    'bus-pinbus',
    'exchange-vertical',
    'wheelchair',
    'universal-acces',
    'shine',
    'information',
    'information-fill',
    'gem',
    'equipment',
    'coins-growth',
    'angle-down',
    'angle-up',
    'angle-left',
    'angle-right',
    'angle-down-small',
    'angle-up-small',
    'angle-left-small',
    'angle-right-small',
    'long-arrow-up',
    'long-arrow-down',
    'long-arrow-left',
    'long-arrow-right',
    'redirect',
    'futbol',
    'link',
    'pulsera',
    'pulsera-slash',
    'car-keys',
    'taxi',
    'manilla',
    'mobile-sticker',
    'stone',
    'flashlight',
    'user-form',
    'mobile-check',
    'layers',
    'tablet',
    'copy',
    'font',
    'toggle',
    'medal-2',
    'Sufi',
    'foundation',
    'ipuzzle-piece',
    'iproject-diagram',
    'mail-lock',
    'id-key',
    'id-lock',
    'mobile-chat',
    'invoice-add',
    'invoice-edit',
    'invoice-search',
    'chat-lock',
    'bank-add',
    'face-cat',
    'face-dog',
    'bezier',
    'paper-plane',
    'dot',
    'shield-money',
    'shield-car-soat',
    'shield',
    'hand-holding-box',
    'plug',
    'walking',
    'user-direct',
    'user-check-money',
    'user-check-2',
    'user-plus',
    'users-check',
    'ico-constructor',
    'hiking',
    'users',
    'constructor-team',
    'hand-holding-coin',
    'gas-pump',
    'paperclip',
    'industry-money',
    'industry',
    'store-error',
    'store-ok',
    'store-add',
    'store-pending',
    'square-plus',
    'wallet-coin',
    'hand-investment',
    'hand-handshake',
    'settings-2',
    'ice-cream',
    'apple',
    'frontify',
    'line-whatsapp',
    'line-facebook',
    'line-instagram',
    'line-linkedin',
    'line-youtube',
    'line-twitter',
    'muverang',
    'safe-box',
    'hand-holding-card',
    'key',
    'money-plus',
    'shopping-cart-plus',
    'file-add',
    'aling-center',
    'aling-justify',
    'circle-money',
    'plant',
    'headset',
    'briefcase-bank',
    'check-box',
    'lock-error',
    'book-2',
    'calendar-historical',
    'calendar-star',
    'calendar-month',
    'car-id',
    'phone-card',
    'phone-card-slash',
    'sack-cash',
    'hand-holding-cash',
    'money',
    'money-2',
    'send-money-from-2',
    'send-money-to-2',
    'money-minus',
    'international-payment',
    'chart-bar',
    'chart-bar-separate',
    'chart-pie-2',
    'chart-analytics',
    'comments-dots',
    'comment-dots',
    'popcorn',
    'lock-dynamic-key',
    'cloud-sun',
    'comment-line',
    'imobile-wave',
    'mobile',
    'card-contactless',
    'calendar-stopwatch',
    'document-coin',
    'document-pdf',
    'document-excel-xls',
    'file-check',
    'hand-holding-document',
    'document-download',
    'file-download',
    'document-edit',
    'pencil-edit',
    'trash',
    'fire-extinguisher',
    'id-face',
    'file-money',
    'slider',
    'slider-2',
    'coins',
    'file-search',
    'id-fingerprint',
    'face-id',
    'fire-slash',
    'shopping-cart',
    'hand-holding-coin-2',
    'like-fill',
    'dislike',
    'dislike-fill',
    'hand-thumbs-down',
    'hand-thumbs-up',
    'briefcase-medical',
    'circle-question',
    'card-number',
    'card-id',
    'lightbulb',
    'umbrella',
    'globe',
    'globe-2',
    'gavel',
    'users-2',
    'whatsapp',
    'star',
    'menu-dots-h',
    'menu-dots-v',
    'map-marker',
    'map-marker-plus',
    'sign-in',
    'briefcase',
    'hospital',
    'restroom',
    'newslatter',
    'card-slash',
    'user-slash',
    'view-slash',
    'box',
    'password-input',
    'circle-play',
    'check',
    'printer',
    'invoice',
    'circle-error',
    'card-removing',
    'route-right',
    'money-3',
    'file-coin',
    'paper-plane-money',
    'car-ship',
    'car-subway',
    'circle-check',
    'swimming-pool',
    'files-money',
    'calendar-clock',
    'file-number',
    'money-slash',
    'briefcase-error',
    'briefcase-3',
    'cocktail',
    'chart-bar-window',
    'search-less',
    'isearch-plus',
    'redo-money',
    'forbidden',
    'menu-dots-double-v',
    'circle-pause',
    'circle-minus',
    'circle-plus',
    'car-bus',
    'bike',
    'car-sedan',
    'bike-vintage',
    'bike-road',
    'bike-folding',
    'bike-dual',
    'bike-kids',
    'bike-mountain',
    'motorcycle-scooter',
    'motorcycle-classic',
    'motorcycle-sport',
    'car-hatchback',
    'car-coupe',
    'car-pickup',
    'car-mini-truck',
    'car-suv',
    'car-minivan',
    'face-mask',
    'options-menu',
    'accesibility',
    'arrow3-down',
    'arrow3-left',
    'arrow3-right',
    'arrow3-up',
    'components',
    'widget',
    'elderly',
    'mail-safe',
    'laptop-chat',
    'phone-chat',
    'receipt-add',
    'receipt-edit',
    'receipt-search',
    'password-safe',
    'chat-safe',
    'add-bank',
    'design',
    'cat',
    'dog',
    'figma',
    'currency-euro',
    'currency-peso',
    'send-message',
    'send',
    'asterisk',
    'shield-user',
    'my-products',
    'scooter',
    'game-controller',
    'map',
    'coding',
    'balance',
    'marketplace',
    'power-cord',
    'project',
    'reply-all',
    'forward',
    'reply',
    'token',
    'preparer-User',
    'direct-user',
    'approving-user',
    'user-check',
    'user-error',
    'main-users',
    'achievement',
    'lend',
    'gasoline-tank',
    'bank',
    'attachment',
    'affinity',
    'add-store',
    'pending-store',
    'add_square',
    'whatsapp-outline',
    'facebook-outline',
    'instagram-outline',
    'linkedin-outline',
    'twitter-outline',
    'youtube-outline',
    'microphone',
    'table-settings',
    'megaphone',
    'baby-bottle',
    'arrow-angle-double-left',
    'arrow-angle-double-dow',
    'arrow-angle-double-right',
    'arrow-angle-double-up',
    'tabot',
    'bill',
    'chart-lines',
    'edit-document',
    'food-burger',
    'hand-button',
    'hand-index',
    'hand-three-fingers',
    'hand-top',
    'hand-two-fingers',
    'hand',
    'menu',
    'QR-add',
    'savings',
    'search-charts',
    'send-money-2',
    'sort',
    'puntos-colombia-2',
    'motorcycle-touring',
    'bike-bmx',
    'motocar',
    'motorcycle-enduro',
    'motorcycle-chopper',
    'motorcycle-quad',
    'bike-electric',
    'megaphone-small',
    'check-small',
    'error-small-2',
    'lightbulb-small',
    'hand-five-small',
    'face-dog-small',
    'alert-2-small',
    'building-pay',
];

const BC_ILLUSTRATION_IMAGES = [
    'il-accept-terms',
    'il-activation-face-id',
    'il-ad-products',
    'il-adn',
    'il-amex',
    'il-app-1',
    'il-app-2',
    'il-app-processes-2',
    'il-app-processes',
    'il-birthday',
    'il-calendar-home',
    'il-camera-permissions',
    'il-car-key',
    'il-car-trip',
    'il-card-financing',
    'il-cards-1',
    'il-cards-2',
    'il-cash-atm',
    'il-chemistry',
    'il-christmas',
    'il-compare-products',
    'il-configure-face-id-1',
    'il-configure-face-id-2',
    'il-configure-face-id',
    'il-configure-touch-id',
    'il-currency-pay',
    'il-devices',
    'il-enrollment-1',
    'il-enrollment-2',
    'il-enrollment-3',
    'il-enrollment-indicator',
    'il-entertainment',
    'il-explore-home',
    'il-explore-items',
    'il-explore-money',
    'il-face-id-wrong',
    'il-family-1',
    'il-family-home',
    'il-fee-simulation',
    'il-generic-bc',
    'il-gift',
    'il-growth',
    'il-habitat-construction',
    'il-habitat-sustainable-project',
    'il-habitat-sustainable',
    'il-hand-select',
    'il-hardtoken-2',
    'il-hardtoken',
    'il-help',
    'il-hexagono',
    'il-holy-communion',
    'il-home-check-list',
    'il-location-home',
    'il-location-mobility',
    'il-location',
    'il-love',
    'il-manage-enrollment',
    'il-marriage',
    'il-master-seek',
    'il-master',
    'il-money-saving',
    'il-networking',
    'il-no-customer',
    'il-not-found',
    'il-pay-card',
    'il-pre-approved-credit-online',
    'il-process-error',
    'il-process-mistake',
    'il-process-ok',
    'il-process-successful',
    'il-puntos-colombia',
    'il-qr-code',
    'il-register-bill-2',
    'il-register-bill-3',
    'il-register-bill',
    'il-request-accounts',
    'il-request-cards',
    'il-saving-car',
    'il-saving-home-1',
    'il-saving-home',
    'il-scan-qr',
    'il-select',
    'il-send-receive-qr',
    'il-setting-biometric-face',
    'il-setting-biometric',
    'il-setting-wallet',
    'il-signature',
    'il-softcorrecten',
    'il-softoken-2',
    'il-softoken',
    'il-store',
    'il-sv-process',
    'il-touch-id-activacion-1',
    'il-touch-id-activacion-2',
    'il-touch-id-activation',
    'il-vehicle-offer',
    'il-visa',
    'il-wallet-activation-1',
    'il-wallet-activation-2',
    'il-wallet-success',
    'il-wallet',
];

const BC_LOGOS = [
    'bam-grupo-horizontal',
    'bam-grupo-vertical',
    'Bam-horizontal',
    'bam-vertical',
    'banca-inversion-horizontal',
    'banca-inversion-vertical',
    'bancoagrario-grupo-horizontal',
    'bancoagrario-grupo-vertical',
    'bancoagrario-horizontal',
    'bancoagrario-vertical',
    'bancolombia-grupo-horizontal',
    'bancolombia-grupo-vertical',
    'bancolombia-cayman-horizontal',
    'bancolombia-cayman-vertical',
    'bancolomba-panama-horizontal',
    'bancolombia-panama-vertical',
    'bancolombia-puertorico-horizontal',
    'bancolombia-puertorico-vertical',
    'isotipo-bancolombia',
    'bancolombia-horizontal',
    'bancolombia-vetical',
    'grupo-bancolombia-banitsmo-horizontal',
    'grupo-bancolomba-banitsmo-vertical',
    'banitsmo-horizontal',
    'banitsmo-vertial',
    'fundacion-grupo-bancolombia-horizontal',
    'fundacion-grupo-bancolombia-vertical',
    'grupo-bancolombia',
    'grupo-bancolombia-horizontal',
    'grupo-bancolombia-vertical',
    'logo-vigilado',
];

const BC_PICTOGRAM_IMAGES_LIST = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'acciones',
    'add',
    'affection',
    'agenda',
    'ahorro',
    'alimentacion',
    'apartaestudio',
    'apartamento',
    'archivo',
    'armor-user',
    'asistencia_medica',
    'ayuda',
    'badge',
    'BB_multicolor_asistencias',
    'BB_multicolor_avances_desembolsos',
    'billete',
    'billetera',
    'bloqueos',
    'botiquin',
    'boton_bancolombia',
    'busqueda',
    'camara_foto',
    'canales',
    'capital_pic',
    'casa',
    'centro_de_ayuda',
    'Chart',
    'chatea_con_nosotros',
    'cheques',
    'clave',
    'clave_dinamica',
    'computadora',
    'configuracion',
    'conoce_nuestra_app',
    'consultar_productos',
    'contacta_con_tu_asesor',
    'Copia de idea',
    'Copia de idioma',
    'corazon',
    'correct',
    'crediagil',
    'creditoapartaestudio',
    'creditoapartamento',
    'creditobici',
    'creditocarro',
    'creditocasa',
    'creditomoto',
    'creditos',
    'cuentas',
    'defensor_financiero',
    'Definir',
    'Desarrollar',
    'descripcion',
    'Descubrir',
    'Despegar',
    'dia a dia',
    'direccionamiento',
    'documento',
    'documentos',
    'documento_entrega',
    'electronic_card',
    'electronic_prepay',
    'Empezar 1',
    'entretenimiento',
    'error-1',
    'explore',
    'extintor',
    'extras',
    'face-angry-color',
    'face-laugh-color',
    'face-laugh-wink-color',
    'face-laughbeam-color',
    'face-meh-color',
    'face-sad-color',
    'face-smile-color',
    'face-wink-color',
    'failure',
    'financieras',
    'financiero',
    'flecha_arriba',
    'flecha_ascendente',
    'flecha_derecha',
    'flypass-color',
    'goal',
    'hogar',
    'huella',
    'idea-color',
    'idioma',
    'imprimir',
    'impuestos',
    'ingreso_efectivomodeda',
    'inscribir_productos',
    'intercambio_divisas',
    'inversiones',
    'key',
    'like-color',
    'lineas_atencion',
    'mail-color',
    'mano_1',
    'mano_2',
    'mano_3',
    'mano_4-1',
    'mano_4',
    'mano_5',
    'mano_cubrir',
    'mano_palma',
    'mascotas',
    'moda',
    'ninos',
    'notificacion',
    'novedades',
    'no_contact',
    'nublado',
    'ofertas',
    'oficina',
    'otros',
    'otros_bancos',
    'p-education',
    'pagar_tarjetas_de_credito',
    'pagar_y_administrar_facturas',
    'pago_movil',
    'plant',
    'porcentaje',
    'power cord',
    'preferente',
    'preguntas_frequentes',
    'premium-star',
    'prestamos',
    'producto_destino',
    'producto_origen',
    'prohibido_fumar',
    'project-color',
    'puntoscolombia',
    'puntos_atencion',
    'recibir_dinero',
    'renovar',
    'rentabilidad',
    'retirar_tarjeta',
    'rocket',
    'salario',
    'salud',
    'search2',
    'seguridad-42',
    'seguridad-88',
    'seguros-57',
    'servicio_mixto',
    'shield-money',
    'simulador',
    'smart_watch',
    'soleado',
    'solicitar_productos',
    'sonido_activo',
    'stone',
    'tarjeta',
    'tarjetascredito',
    'Tecnologia',
    'temperatura',
    'te_llamamos',
    'theory',
    'thumbtack-color',
    'tienda',
    'time_pic',
    'pic_change',
    'angle_down',
    'pic_download',
    'tips_seguridad',
    'transferir_dinero',
    'transporte',
    'user error',
    'usuario-1',
    'usuario',
    'valor',
    'valores copia',
    'viajes',
    'visible',
];

const BC_STROKE_IMAGES_LIST = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15'];

const KIND_NAMES_ICONS = {
    pictograms: BC_PICTOGRAM_IMAGES_LIST,
    strokes: BC_STROKE_IMAGES_LIST,
    illustrations: BC_ILLUSTRATION_IMAGES,
    functionals: BC_FUNCTIONAL_ICONS,
    logos: BC_LOGOS,
};
const MAP = {};
for (const key in KIND_NAMES_ICONS) {
    if (Object.prototype.hasOwnProperty.call(KIND_NAMES_ICONS, key)) {
        const element = KIND_NAMES_ICONS[key];
        for (const icon of element) {
            MAP[icon] = key;
        }
    }
}

class BcConfigIconModule {
}
const CONFIG = new InjectionToken("forRoot() BcIconModule configuration.");

const SIZES = {
    xs: 'bc-xs',
    '2xs': 'bc-2xs',
    sm: 'bc-sm',
    md: 'bc-md',
    lg: 'bc-lg',
    xl: 'bc-xl',
    '2xl': 'bc-2xl',
    '3xl': 'bc-3xl',
};
/**
 * Iconos del showcase
 * @export
 * @class BcIconComponent
 */
class BcIconComponent {
    /**
     * @param elementRef Referencia del host
     * @param ariaHidden Se toma el valor del parametro aria-hidden, si no existe el atributo se pone en true
     */
    constructor(elementRef, ariaHidden, renderer, config) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.cachedMatches = {};
        /**
         * Tamaño en pixeles del recurso. Por defecto son 100px
         * @type {string}
         * @memberof BcIconComponent
         */
        this.width = '100px';
        this.config = config;
        if (!ariaHidden) {
            elementRef.nativeElement.setAttribute('aria-hidden', 'true');
        }
    }
    get hostClasses() {
        return ['bc-icon', this.setSize(), this.class].join(' ');
    }
    /**
     * Configura el tamaño a usar para los íconos, por defecto se establece en SM
     * @returns
     * @memberof BcIconComponent
     */
    setSize() {
        let response = SIZES[this.size];
        if (!response) {
            response = SIZES.sm;
        }
        return response;
    }
    ngOnInit() {
        this.validateIcon();
    }
    ngAfterViewInit() {
        if (this.ariaLabel) {
            this.elementRef.nativeElement
                .setAttribute('aria-label', this.ariaLabel);
        }
    }
    ngOnChanges() {
        this.validateIcon();
    }
    validateIcon() {
        if (this.name) {
            const typeIcon = MAP[this.name];
            if (typeIcon == 'functionals' || typeIcon == 'logos') {
                this.buildIcon(typeIcon);
            }
            else {
                this.buildImage(typeIcon);
            }
        }
    }
    buildIcon(typeIcon) {
        this.elementRef.nativeElement.textContent = this.name;
        if (typeIcon == 'logos') {
            this.renderer.setStyle(this.elementRef.nativeElement, 'width', 'auto');
        }
    }
    buildImage(typeIcon) {
        const path = `${this.config.path}/assets/icons/${typeIcon}/${this.name}`;
        const IMAGE_URL = `${path}.svg`;
        const IMG = this.renderer.createElement('img');
        this.renderer.setAttribute(IMG, 'src', IMAGE_URL);
        this.renderer.setStyle(this.elementRef.nativeElement, 'width', this.width);
        this.renderer.setStyle(IMG, 'width', this.width);
        let childCount = this.elementRef.nativeElement.childNodes.length;
        while (childCount--) {
            const child = this.elementRef.nativeElement.childNodes[childCount];
            this.elementRef.nativeElement.removeChild(child);
        }
        this.renderer.appendChild(this.elementRef.nativeElement, IMG);
    }
}
BcIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcIconComponent, deps: [{ token: i0.ElementRef }, { token: 'aria-hidden', attribute: true }, { token: i0.Renderer2 }, { token: BcConfigIconModule }], target: i0.ɵɵFactoryTarget.Component });
BcIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: BcIconComponent, selector: "bc-icon", inputs: { ariaLabel: "ariaLabel", size: "size", width: "width", name: "name", class: "class" }, host: { attributes: { "role": "img" }, properties: { "class": "this.hostClasses" } }, usesOnChanges: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bc-icon',
                    template: '<ng-content></ng-content>',
                    host: { role: 'img' },
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Attribute,
                    args: ['aria-hidden']
                }] }, { type: i0.Renderer2 }, { type: BcConfigIconModule }]; }, propDecorators: { ariaLabel: [{
                type: Input
            }], size: [{
                type: Input
            }], width: [{
                type: Input
            }], name: [{
                type: Input
            }], class: [{
                type: Input
            }], hostClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 * Importa el componente y la directiva de iconos con
 * los diseños de Bancolombia S.A.
 *
 * @componente <bc-icon></bc-icon>
 * @param  class Clase CSS
 * @param  size Tamaño del icono values [ xs || 2xs || sm (Default) || md || lg || xl || 2xl || 3xl ]
 * @example
 *
 * <bc-icon bc-icon
 *      size="xl"
 *      class="'mi-icono'">
 * </bc-icon>
 *
 * @author: Bancolombia S.A
 */
class BcIconModule {
    static forRoot(conf = defaultConfig) {
        return {
            ngModule: BcIconModule,
            providers: [{ provide: BcConfigIconModule, useValue: conf }],
        };
    }
}
BcIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BcIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcIconModule, declarations: [BcIconComponent], exports: [BcIconComponent] });
BcIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcIconModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BcIconComponent],
                    imports: [],
                    exports: [BcIconComponent],
                }]
        }] });
const defaultConfig = new BcConfigIconModule();
defaultConfig.path = '';

/**
 * Generated bundle index. Do not edit.
 */

export { BC_FUNCTIONAL_ICONS, BC_ILLUSTRATION_IMAGES, BC_LOGOS, BC_PICTOGRAM_IMAGES_LIST, BC_STROKE_IMAGES_LIST, BcIconComponent, BcIconModule, SIZES };
